import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import FuneralServicesSelector from './FuneralServicesSelector';

const FuneralServiceSelectorModal = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Seleziona un Defunto
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FuneralServicesSelector onChange={props.onChange} />
      </Modal.Body>
    </Modal>
  );
};

FuneralServiceSelectorModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onChange: PropTypes.func,
};

export default FuneralServiceSelectorModal;
